$(document).foundation();
jQuery(document).ready(function($) {
	var form = $('#conversion-form');
	form.on('submit', function(ev) {
		ev.preventDefault()

    	var inputs = form.find(':input');
		RdIntegration.post(inputs.serializeArray());
		
	  });
	  
	$(window).scroll(function () {
      if ($(this).scrollTop() >= 5) {
          $('#header').addClass("stuck");
      } else {
          $('#header').removeClass("stuck");
      }
	});

	$(window).scroll();

	$('.js-waypoint').css('opacity', 0);

	var waypoint = $('.js-waypoint-fadeIn').waypoint(function(direction) {
		$(this.element).toggleClass('fadeIn');
	}, { offset: '90%' });

	$('nav a[href="#"]').click(function(event) {
		event.preventDefault();
	});

	$('.abrir-menu').click(function(event) {
		event.preventDefault();
		$('body').css('overflow','hidden');
		$('#nav').addClass('open');
		$('#nav').animate({opacity: 1}, 400);

		$(this).animate({
			opacity: 0,
		},
		400, function() {
			$(this).hide();
			$('.fechar-menu').show();
			$('.fechar-menu').animate({opacity: 1}, 400);
		});
	});

	$('.fechar-menu').click(function(event) {
		event.preventDefault();
		$('body').css('overflow','auto');
		$('#nav').animate({opacity: 0}, 400, function(){
			$('#nav').removeClass('open');
		});

		$(this).animate({
			opacity: 0,
		},
		400, function() {
			$(this).hide();
			$('.abrir-menu').show();
			$('.abrir-menu').animate({opacity: 1}, 400);
		});
	});

	$('.js-duvidas-filtro a').click(function(e) {
		e.preventDefault();
		$('.js-duvidas-filtro a').removeClass('active');
		$(this).addClass('active');

		var selected = $(this).attr('href');
		$('.duvida:visible').fadeOut(250, function() {
			$(selected).fadeIn(500, function() {
				Waypoint.refreshAll();
			});
		});
	});

	$('.js-duvidas-filtro li:first-child() a').click();

	$('.js-materiais-filtro a').click(function(e) {
		e.preventDefault();
		$('.js-materiais-filtro a').removeClass('active');
		$(this).addClass('active');

		var selected = $(this).attr('href');
		$('.tipo:visible').fadeOut(250, function() {
			$(selected).fadeIn(500, function() {
				Waypoint.refreshAll();
			});
		});
	});

	//$('.js-materiais-filtro li:first-child() a').click(); materiais ricos antigo

	$('.js-cases-filtro a').click(function(e) {
		e.preventDefault();
		$('.js-cases-filtro a').removeClass('active');
		$(this).addClass('active');

		var selected = $(this).attr('href');
		$('.modulo:visible').fadeOut(250, function() {
			$(selected).fadeIn(500, function() {
				Waypoint.refreshAll();
			});
		});
	});

	$('#recentes').click(); //clicka no #recentes para nao aparecer todos listados

	$('.js-recursos-veja-mais').click(function(e) {
		e.preventDefault();
		$(this).hide();

		$('.hide-recurso').fadeIn();
	});

	$('.js-fechar-estudos').click(function(e) {
		e.preventDefault();
		$('.estudos-cta').fadeIn();
		$('#estudos-links').hide();
	});

	$('.js-slider-depoimentos').slick({
	    centerMode: false,
	    slidesToShow: 1,
	    variableWidth: false,
	    adaptiveHeight: true,
	    infinite: false,
	    useCSS: false,
	    fade: true,
	    prevArrow: '#slider-depoimentos-prev',
	    nextArrow: '#slider-depoimentos-next',
	    dots: true,
	    appendDots: '#slider-depoimentos-dots'
	});

	console.log("ld");
	$("#quero").click(function(event) { //CTA Dentro dos blogposts para conversao
    event.preventDefault();
    console.log(jQuery('#conversion-form').serialize());
    if (validateCta()) {
      var data_array = [{
          name: 'email',
          value: $("#email-cta").val()
        },
        {
          name: 'identificador',
          value: 'conversion-form'
        },
        {
          name: 'token_rdstation',
          value: '1df98ec84713d88b9ccfaaa6429c8eda'
        },
        {
          name: 'nome',
          value: $("#nome-cta").val()
        }
      ];
			console.log(data_array);
      RdIntegration.post(data_array, function() {
        swal("Obrigado pelo interesse em aprender conosco!","","success");
      });
    }
  });
	$("#cw-newsletter-lateral input.uf-submit").click(function(event) { //CTA Dentro dos blogposts para conversao
    event.preventDefault();
    console.log(jQuery('#cw-newsletter-lateral form').serialize());
    if (validateNewsLat()) {
      var data_array = [{
          name: 'email',
          value: $("#cw-newsletter-lateral [name=name]").val()
        },
        {
          name: 'identificador',
          value: 'conversion-form'
        },
        {
          name: 'token_rdstation',
          value: '1df98ec84713d88b9ccfaaa6429c8eda'
        },
        {
          name: 'name',
          value: $("#cw-newsletter-lateral [name=email]").val()
        }
      ];
			console.log(data_array);
      RdIntegration.post(data_array, function() {
        swal("Obrigado pelo interesse em aprender conosco!","","success");
      });
    }
  });

  function validateCta() {
    if ($("#conversion-form #nome").val().length < 1 || $("#conversion-form #email").val().length < 1) {
      swal("Preencha todos os campos", "", "error");
      return false;
    }
    return true;
  }

  function validateNewsLat() {
    if ($("#cw-newsletter-lateral [name=name]").val().length < 1 || $("#cw-newsletter-lateral [name=email]").val().length < 1) {
      swal("Preencha todos os campos", "", "error");
      return false;
    }
    return true;
  }


});

function goTo(selector){
	jQuery('html, body').animate({
		scrollTop: jQuery(selector).offset().top
	}, 1000);
}

new dgCidadesEstados({
	cidade: document.getElementById('cidade'),
	estado: document.getElementById('estado')
});